import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

try {
    window.Pusher = Pusher;

    // Debug: Log environment variables to see what was baked into the build
    const echoConfig = {
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'http') === 'https',
        enabledTransports: ['ws', 'wss'],
    };

    console.log('Echo Config:', {
        key: echoConfig.key,
        wsHost: echoConfig.wsHost,
        wsPort: echoConfig.wsPort,
        scheme: import.meta.env.VITE_REVERB_SCHEME,
    });

    // Check if key is missing
    if (!echoConfig.key) {
        console.error('VITE_REVERB_APP_KEY is not set! Echo will not be initialized.');
        console.error('This means the build happened without VITE_REVERB_APP_KEY environment variable.');
    } else {
        window.Echo = new Echo(echoConfig);
        console.log('Echo initialized successfully');
    }
} catch (error) {
    console.error('Failed to initialize Echo:', error);
}
